import { render, staticRenderFns } from "./Logger.vue?vue&type=template&id=4ec5632a&"
import script from "./Logger.vue?vue&type=script&lang=js&"
export * from "./Logger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports